/* @flow */
export const validation = {
  titleMaxChar: 120,
  paragraphMaxChar: 1500
}
